/* eslint-disable react/prop-types */
import translating from '../../translate.json';
import closeIcon from '../../assets/images/close.png';

import './style.scss';

/**
 * DrawerHeader component - Renders the header section of a drawer
 * @component
 * @param {Object} props - Component props
 * @param {string} props.title - Translation key for the drawer title
 * @param {Function} props.setOpenDrawer - Callback function to toggle drawer open/closed state
 * @returns {JSX.Element} A div containing the drawer header with title and close button
 */
export default function DrawerHeader(props) {
  return (
    <div className="drawer-header">
      <div className="drawer-title">{translating[props.title]}</div>
      <img
        className="close-drawer"
        src={closeIcon}
        onClick={() => props.setOpenDrawer(false)}
      ></img>
    </div>
  );
}
